/**
 * Environment-aware logging utility
 * Provides console logging that can be disabled in production builds
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Logger = /** @class */ (function () {
    function Logger(config) {
        if (config === void 0) { config = {}; }
        this.levels = {
            debug: 0,
            info: 1,
            warn: 2,
            error: 3,
        };
        this.config = __assign({ enabledInProduction: false, enabledInDevelopment: true, minLevel: "debug" }, config);
    }
    Logger.prototype.shouldLog = function (level) {
        var isProduction = process.env.NODE_ENV === "production";
        var isDevelopment = process.env.NODE_ENV === "development";
        // Check if logging is enabled for current environment
        if (isProduction && !this.config.enabledInProduction) {
            return false;
        }
        if (isDevelopment && !this.config.enabledInDevelopment) {
            return false;
        }
        // Check if level meets minimum threshold
        return this.levels[level] >= this.levels[this.config.minLevel];
    };
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.shouldLog("debug")) {
            console.debug.apply(console, args);
        }
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.shouldLog("info")) {
            console.info.apply(console, args);
        }
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.shouldLog("info")) {
            console.log.apply(console, args);
        }
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.shouldLog("warn")) {
            console.warn.apply(console, args);
        }
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.shouldLog("error")) {
            console.error.apply(console, args);
        }
    };
    Logger.prototype.group = function (label) {
        if (this.shouldLog("info")) {
            console.group(label);
        }
    };
    Logger.prototype.groupEnd = function () {
        if (this.shouldLog("info")) {
            console.groupEnd();
        }
    };
    Logger.prototype.time = function (label) {
        if (this.shouldLog("debug")) {
            console.time(label);
        }
    };
    Logger.prototype.timeEnd = function (label) {
        if (this.shouldLog("debug")) {
            console.timeEnd(label);
        }
    };
    return Logger;
}());
// Create logger instances for different purposes
export var logger = new Logger();
export var performanceLogger = new Logger({
    enabledInProduction: false,
    enabledInDevelopment: true,
    minLevel: "info",
});
export var errorLogger = new Logger({
    enabledInProduction: true,
    enabledInDevelopment: true,
    minLevel: "error",
});
export var buildLogger = new Logger({
    enabledInProduction: false,
    enabledInDevelopment: true,
    minLevel: "info",
});
export default logger;
